/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrg = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization/getAll`,param).then(res => res.data)
}
const createOrg = (org) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization/create`,org).then(res => res.data)
}
const editOrg = (org) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization/update`,org).then(res => res.data)
}
const getAllOrgHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization/get-history`,param).then(res => res.data)
}
export {
    getAllOrg,
    createOrg,
    editOrg,
    getAllOrgHistory
}
